import _ from 'underscore';
import Marionette from 'backbone.marionette';
import ObjectUtil from '@component/common/src/util/ObjectUtil';
import mvCookie from '@component/common/src/util/Cookie';
import TagManagerUtil from '@component/common/src/util/TagManagerUtil';
import {
  format,
  CURRENCY,
  NUMBER,
} from '@component/common/src/util/TealiumFormattingUtil';
import ProductTemplate from '../templates/partials/quick-bag/quickBagProduct.hbs';
import QuickBagAnalytics from '../components/QuickBagAnalytics';

const QuickBagProductView = Marionette.ItemView.extend({
  tagName: 'li',
  template: ProductTemplate,
  ui: {
    remove: '.button-remove',
    image: '.productImage',
    quickBagProductDetail: '.quickbagproduct-detail',
  },
  events: {
    'click @ui.remove': 'removeProductFromBag',
    'click @ui.image': 'onProductImageClick',
    'click @ui.quickBagProductDetail': 'quickBagProductDetailClick',
  },

  initialize(options) {
    this.parentView = options.parentView;
  },

  // ###Method - removeProductFromBag()  removes the current product from the model and triggers a DELETE API call
  // > returns
  // >
  // + None
  removeProductFromBag() {
    this.model.destroy({
      success: (model, response) => {
        // calls parentview onChildModelDestroy to update the new model and collections
        // was unable to use childEvent because the view is destroyed when model is destroyed
        const modelJson = this.parentView.model.toJSON();
        const { bagItems } = modelJson;
        response.isSkipBagOnQuickBagEnabled = modelJson.isSkipBagOnQuickBagEnabled || false;
        if (response.meta) {
          response.meta.isSkipBagOnQuickBagEnabled = ObjectUtil.getChildProperty(modelJson, 'meta.isSkipBagOnQuickBagEnabled') || false;
          response.meta.isTaggingOnQuickBagEnabled = ObjectUtil.getChildProperty(modelJson, 'meta.isTaggingOnQuickBagEnabled') || false;
        }
        this.parentView.onChildModelDestory(response);
        QuickBagAnalytics.fireElementTag('remove');
        this.removeTag(response, bagItems);
      },
    });
  },

  removeTag(response, bagItems) {
    const afterRemoveBagItems = response.bagItems;
    const deletedItems = bagItems.filter(item => _.findIndex(afterRemoveBagItems, remItem => remItem.product.id === item.product.id) === -1);
    const moreItemsDeleted = deletedItems.length > 1;
    const self = this;
    _.each(deletedItems, (deletedItem) => {
      self.productRemoveTag(deletedItem, moreItemsDeleted);
    });
  },

  productRemoveTag(deletedItem, moreItemsDeleted) {
    const product = deletedItem.product || {};
    const getPrice = (priceObj) => {
      const values = priceObj.value;
      if (values && values.length && values[0]) {
        return values[0].toString();
      }
      return '';
    };
    const tieredPrices = ObjectUtil.getChildProperty(product, 'pricing.price.tieredPrice') || [];
    const orgPrice = getPrice(tieredPrices[0] || {});
    const price = tieredPrices.length > 1 ? getPrice(tieredPrices[tieredPrices.length - 1]) : orgPrice;
    const subTotal = (parseFloat(price) * parseInt(deletedItem.quantity, 10)) || '';
    const flags = product.detail ? product.detail.flags : {};
    const getRemoveType = (flag) => {
      if (moreItemsDeleted) {
        return (flag ? 'automatic' : '');
      }
      return (flag ? 'manual' : '');
    };
    const registryUrl = deletedItem.registry ? deletedItem.registry.registryUrl : '';
    const urlFrags = registryUrl.split('/');
    const bagItemsCount = mvCookie.get('CartItem', 'GCs');

    let bagEmptyFlag;

    if (!_.isUndefined(bagItemsCount)) {
      bagEmptyFlag = bagItemsCount === '0' ? 'true' : 'false';
    }

    TagManagerUtil.fireTag('link', {
      event_name: 'bag update',
      product_color: format(ObjectUtil.getChildProperty(product, 'traits.colors.selectedColor.name')),
      product_id: format(product.id),
      product_name: format(ObjectUtil.getChildProperty(product, 'detail.name')),
      product_original_price: format(orgPrice, CURRENCY),
      product_prev_quantity: format(deletedItem.quantity, NUMBER),
      product_price: format(flags.gwpIndicator ? '0' : price, CURRENCY),
      product_quantity: format('0'),
      product_size: format(ObjectUtil.getChildProperty(product, 'traits.size.selectedSize.name')),
      product_sub_total: format(subTotal, NUMBER),
      product_pwp_remove_type: format(getRemoveType(flags.pwpIndicator)),
      product_gwp_remove_type: format(getRemoveType(flags.gwpIndicator)),
      product_registry_number: format(_.last(urlFrags)),
      is_bag_empty: bagEmptyFlag || '',
    });
  },

  onProductImageClick() {
    QuickBagAnalytics.fireManualLinkTag(this.parentView.model.toJSON(), 'product-thumbnail', 'QUICK-BAG-TO-PDP');
  },
  quickBagProductDetailClick() {
    TagManagerUtil.fireTag('link', { event_name: 'minibag product click' });
  },

});

export default QuickBagProductView;
